const React = require('react');

const Container = require('../common/Container.jsx');
const Content = require('../common/Content.jsx');
const Token = require('../utility/Token.jsx');
const Totals = require('../common/Totals.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region BALANCE

function Balance(props) {
    let includes = {};
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    const data = props.data || {};
    let value = data.Balance;
    if (data.Payments && data.Payments.length == 0 && !includes.NoPayments) {
        value = undefined;
    }
    return <Content.LabelValue {...props} renderPlaceholder={value == undefined} value={value} />;
}
const TypeConfigBalance = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Balance' }); },
        format: Content.TypeConfig.labelValue.panel.format,
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'If no payment(s)', name: 'NoPayments', type: 'checkbox', value: true }
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion BALANCE

// #region BALANCE V2

function _BalanceV2(props) {
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    let hasValue;
    if (blockProps.includeNoPayments || (!blockProps.includeNoPayments && data.Payments && data.Payments.length > 0)) {
        hasValue = true;
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const BalanceV2 = Content.withLabelTokenParsing(_BalanceV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Balance:
            if (data.ExchangeRate && data.ExchangeRate.Balance != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Balance, options);
            }
            break;
        case Token.Total.Balance:
            if (data.Balance != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Balance, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensBalance = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Balance', defaultValue, Token.Total.Balance),
        Token.getWrappedTokenConfig('Balance (Display Currency)', Token.DisplayCurrency.Balance)
    ];
};
const TypeConfigBalanceV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(2, [{
            display: 'Display if no payment(s)',
            fullWidth: true,
            group: 'block',
            name: 'includeNoPayments',
            type: 'checkbox',
            value: true
        }]),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Balance' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Balance}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Balance }))
    }
};

// #endregion BALANCE V2

// #region PAID

function Paid(props) {
    let includes = {};
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    const data = props.data || {};
    let value = data.Paid;
    if (data.Payments && data.Payments.length == 0 && !includes.NoPayments) {
        value = undefined;
    }
    return <Content.LabelValue {...props} renderPlaceholder={value == undefined} value={value} />;
}
const TypeConfigPaid = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Total Paid' }); },
        format: Content.TypeConfig.labelValue.panel.format,
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'If no payment(s)', name: 'NoPayments', type: 'checkbox', value: true }
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion PAID

// #region PAID V2

function _PaidV2(props) {
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    let hasValue;
    if (blockProps.includeNoPayments || (!blockProps.includeNoPayments && data.Payments && data.Payments.length > 0)) {
        hasValue = true;
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const PaidV2 = Content.withLabelTokenParsing(_PaidV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Paid:
            if (data.ExchangeRate && data.ExchangeRate.Paid != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Paid, options);
            }
            break;
        case Token.Total.Paid:
            if (data.Paid != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Paid, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensPaid = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Paid', defaultValue, Token.Total.Paid),
        Token.getWrappedTokenConfig('Paid (Display Currency)', Token.DisplayCurrency.Paid)
    ];
};
const TypeConfigPaidV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(2, [{
            display: 'Display if no payment(s)',
            fullWidth: true,
            group: 'block',
            name: 'includeNoPayments',
            type: 'checkbox',
            value: true
        }]),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Total Paid' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Paid}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Paid }))
    }
};

// #endregion PAID V2

// #region PROMO CODES

function PromoCodes(props) {
    const data = props.data || {};
    if (!props.builder && (!data.PromoCodes || !data.PromoCodes.length)) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {};
    let formatProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
        if (config.Config.Format) {
            formatProps = config.Config.Format;
        }
    }
    let styleDescription;
    if (includes.Description) {
        styleDescription = Utilities.Config.getStyle(data, blockProps, 'Description');
        if (blockProps.displayType == 'inline' && !Utilities.isNullOrWhitespace(blockProps.marginRightDescription)) {
            styleDescription.marginRight = blockProps.marginRightDescription;
        } else {
            styleDescription.marginRight = undefined
        }
    }
    const rowStyle = {};
    if (!Utilities.isNullOrWhitespace(blockProps.rowSpacing)) {
        rowStyle.paddingTop = blockProps.rowSpacing;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            {
                data.PromoCodes &&
                data.PromoCodes.map(function (d, i) {
                    let description;
                    if (includes.Description && d.Description && d.Description.length) {
                        description = <span style={styleDescription}>{d.Description}</span>;
                    }
                    let formatValue, value;
                    if (d.DiscountType == 2) {
                        value = d.Discount;
                    } else {
                        value = Utilities.Format.Percent.getDisplayString(d.Discount, formatProps.percentFormat);
                    }
                    return (
                        <Content.LabelValue
                            key={i}
                            {...props}
                            container={false}
                            description={description}
                            formatValue={formatValue}
                            label={d.Code}
                            rowStyle={i > 0 ? rowStyle : undefined}
                            value={value} />
                    );
                })
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            (!data.PromoCodes || data.PromoCodes.length == 0) &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}
const TypeConfigPromoCodes = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ includeRows: false }),
                    {
                        display: 'Line Spacing',
                        name: 'rowSpacing',
                        type: 'text',
                        visible: function (config) {
                            return config.Block && config.Block.displayType == 'inline';
                        }
                    },
                    {
                        display: 'Row Spacing',
                        name: 'rowSpacing',
                        type: 'text',
                        visible: function (config) {
                            return config.Block && config.Block.displayType == 'columns';
                        }
                    },
                    { display: 'Description Properties', id: 'descriptionProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({ name: 'Description' }, undefined, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, undefined, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {})
                ]
            };
        },
        format: function () { return TypeConfig.panel.currency({ percent: true }); },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Description', name: 'Description', type: 'checkbox', value: true }
                ]
            };
        },
        style: function () { return TypeConfig.panel.layoutStyle({}, { visible: function (config) { return config.Block && config.Block.displayType == 'inline'; } }); }
    }
};

// #endregion PROMO CODES

// #region PROMO CODES V2

function PromoCodesV2(props) {
    const data = props.data || {};
    const hasPromoCodes = data.PromoCodes && data.PromoCodes.length > 0;
    if (!props.builder && !hasPromoCodes) {
        return null;
    }
    // const config = props.config || {};
    // let blockProps = {};
    // if (config.config && config.config.Block) {
    //     blockProps = config.config.Block;
    // }
    const rowStyle = {};
    // if (blockProps.rowSpacing && !Utilities.isNullOrWhitespace(blockProps.rowSpacing.value)) {
    //     rowStyle.paddingTop = `${blockProps.rowSpacing.value}${blockProps.rowSpacing.unit}`;
    // }
    const localization = data.Gallery && data.Gallery.Localization;
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            {
                data.PromoCodes &&
                data.PromoCodes.map((d, i) =>
                    <PromoCodeLine
                        key={i}
                        {...props}
                        container={false}
                        data={d}
                        localization={localization}
                        rowStyle={i > 0 ? rowStyle : undefined} />
                )
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            !hasPromoCodes &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}
function _PromoCodeLine(props) { return <Content.LabelValue {...props} formatValue={false} value={props.content} /> }
const PromoCodeLine = Content.withLabelTokenParsing(_PromoCodeLine, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.PromoDiscount:
            if (data.DiscountType != 1 && data.ExchangeRate && data.ExchangeRate.Value != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Value, options);
            }
            break;
        case Token.Total.PromoCode.Code:
            if (data.Code != null) {
                replaceString = data.Code;
            }
            break;
        case Token.Total.PromoCode.Description:
            if (data.Description != null) {
                replaceString = data.Description;
            }
            break;
        case Token.Total.PromoCode.Discount:
            if (data.Discount != undefined) {
                replaceString = Utilities.Format.getDiscountString(data, props.index, props.localization, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensPromoCodes = (data) => {
    const discountToken = Token.getCurrencyTokenConfig('Discount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Total.PromoCode.Discount);
    discountToken.options.push({ defaultValue: Utilities.Format.Percent.getDefaultFormatString(), display: 'Percent Format', name: 'percentFormat', note: 'Keywords: [Value]', type: 'percentFormat' })
    return [
        { display: 'Code', token: Token.Total.PromoCode.Code },
        { display: 'Description', token: Token.Total.PromoCode.Description },
        discountToken,
        Token.getWrappedTokenConfig('Discount (Display Currency)', Token.DisplayCurrency.PromoDiscount)
    ]
};
const TypeConfigPromoCodesV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block('3'),
        description: () => Content.TypeConfig.labelValue.panelV2.description(Utilities.wrapTextForEditor({ text: `{${Token.Total.PromoCode.Description}}`, token: Token.Total.PromoCode.Description })),
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: `{${Token.Total.PromoCode.Code}}`, token: Token.Total.PromoCode.Code })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.PromoCode.Discount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","percentFormat":"${Utilities.Format.Percent.getDefaultFormatString()}")}`, token: Token.Total.PromoCode.Discount }))
    }
};

// #endregion PROMO CODES V2

// #region REFUNDED

function Refunded(props) {
    const data = props.data || {};
    let value;
    if (data.HasRefund) {
        value = data.Refunded;
    }
    return <Content.LabelValue {...props} renderPlaceholder={!data.HasRefund} value={value} />;
}
const TypeConfigRefunded = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Total Refunded' }); },
        format: Content.TypeConfig.labelValue.panel.format,
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion REFUNDED

// #region REFUNDED V2

function _RefundedV2(props) {
    const hasValue = props.data && props.data.HasRefund;
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const RefundedV2 = Content.withLabelTokenParsing(_RefundedV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Refunded:
            if (data.ExchangeRate && data.ExchangeRate.Refunded != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Refunded, options);
            }
            break;
        case Token.Total.Refunded:
            if (data.Refunded != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Refunded, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensRefunded = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Refunded', defaultValue, Token.Total.Refunded),
        Token.getWrappedTokenConfig('Refunded (Display Currency)', Token.DisplayCurrency.Refunded)
    ]
};
const TypeConfigRefundedV2 = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Refunded' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: (data) => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Refunded}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Refunded }))
    }
};

// #endregion REFUNDED V2

// #region SUBTOTAL

function Subtotal(props) {
    const data = props.data || {};
    let includes = {};
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    let value = data.Subtotal;
    if (includes.Discount) {
        value = data.SubtotalLessDiscount;
    }
    return <Content.LabelValue {...props} value={value} />;
}
const TypeConfigSubtotal = {
    panel: {
        block: function () { return Content.TypeConfig.labelValue.panel.block({ value: 'Subtotal' }); },
        format: Content.TypeConfig.labelValue.panel.format,
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Discount', name: 'Discount', type: 'checkbox', value: false }
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion SUBTOTAL

module.exports = {
    ...Totals,
    Balance: {
        Component: Balance,
        TypeConfig: TypeConfigBalance
    },
    BalanceV2: {
        Component: BalanceV2,
        Tokens: TokensBalance,
        TypeConfig: TypeConfigBalanceV2
    },
    Paid: {
        Component: Paid,
        TypeConfig: TypeConfigPaid
    },
    PaidV2: {
        Component: PaidV2,
        Tokens: TokensPaid,
        TypeConfig: TypeConfigPaidV2
    },
    PromoCodes: {
        Component: PromoCodes,
        TypeConfig: TypeConfigPromoCodes
    },
    PromoCodesV2: {
        Component: PromoCodesV2,
        Tokens: TokensPromoCodes,
        TypeConfig: TypeConfigPromoCodesV2
    },
    Refunded: {
        Component: Refunded,
        TypeConfig: TypeConfigRefunded
    },
    RefundedV2: {
        Component: RefundedV2,
        Tokens: TokensRefunded,
        TypeConfig: TypeConfigRefundedV2
    },
    Subtotal: {
        Component: Subtotal,
        TypeConfig: TypeConfigSubtotal
    }
};